// EmailJS Configuration
// Replace these with your actual EmailJS credentials
export const EMAILJS_CONFIG = {
	SERVICE_ID: "service_syehdyq", // Your EmailJS service ID
	TEMPLATE_ID: "template_xzs0rle", // Your EmailJS template ID
	PUBLIC_KEY: "Vy64QdYG2j6ozsn9F", // Your EmailJS public key
};

// EmailJS template parameters mapping
export const TEMPLATE_PARAMS = {
	from_name: "from_name",
	from_email: "from_email",
	message: "message",
	to_email: "to_email",
};
